/* ============================================================================
   PETGENTLY LISTICLE — window.__pgListiclePrescription namespace
   Reviews carousel = native scroll-snap + JS dots/arrows (no autoplay).
   Sticky bar = scroll-distance show/hide.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__pgListiclePrescription) return;
  window.__pgListiclePrescription = { initialized: false };

  var SCOPE = '.shopify-section.section-petgently-listicle-prescription';
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  function initReviews(section) {
    var car = section.querySelector('[data-reviews]');
    if (!car) return;
    var viewport = car.querySelector('[data-reviews-viewport]');
    var track = car.querySelector('[data-reviews-track]');
    var dotsWrap = car.querySelector('[data-reviews-dots]');
    if (!viewport || !track) return;
    var slides = $$('[data-reviews-slide]', track);
    if (slides.length === 0) return;

    var idx = 0;
    var total = slides.length;

    function syncDots() {
      if (!dotsWrap) return;
      $$('.pg__reviews-dot', dotsWrap).forEach(function (d, k) {
        d.classList.toggle('is-active', k === idx);
      });
    }

    // Center the reference slide inside the viewport via a track transform.
    function layout(animate) {
      var slide = slides[idx];
      if (!slide) return;
      var offset = (viewport.clientWidth / 2) - (slide.offsetLeft + slide.offsetWidth / 2);
      track.style.transition = animate ? 'transform .4s cubic-bezier(.2,.7,.3,1)' : 'none';
      track.style.transform = 'translateX(' + offset + 'px)';
      syncDots();
    }

    // Infinite loop: past the last slide wraps to the first, and vice-versa.
    function go(d) {
      idx = (idx + d + total) % total;
      layout(true);
    }

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pg__reviews-dot' + (i === idx ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
        (function (k) {
          on(dot, 'click', function () { idx = k; layout(true); });
        })(i);
        dotsWrap.appendChild(dot);
      }
    }

    on(car.querySelector('[data-reviews-dir="prev"]'), 'click', function () { go(-1); });
    on(car.querySelector('[data-reviews-dir="next"]'), 'click', function () { go(1); });
    on(window, 'resize', function () { layout(false); });

    requestAnimationFrame(function () { layout(false); });
  }

  function initStickyBar(section) {
    var bar = section.querySelector('[data-sticky]');
    if (!bar) return;
    var showAfterPct = parseFloat(bar.getAttribute('data-show-after') || '50');
    var hideNearEnd = parseInt(bar.getAttribute('data-hide-near-end') || '92', 10);
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var y = h.scrollTop || window.pageYOffset;
      var pct = max > 0 ? (y / max * 100) : 0;
      var shouldShow = pct >= showAfterPct && pct < hideNearEnd;
      bar.classList.toggle('is-visible', shouldShow);
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    on(window, 'resize', update);
    update();
  }

  function init() {
    if (window.__pgListiclePrescription.initialized) return;
    window.__pgListiclePrescription.initialized = true;
    $$(SCOPE).forEach(function (section) {
      initReviews(section);
      initStickyBar(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('section-petgently-listicle-prescription')) {
      window.__pgListiclePrescription.initialized = false;
      init();
    }
  });
})();